<template>
  <div>
    <v-layout row wrap class="section" v-if="page != 'club'">
      <v-flex xs12 class="name">{{ $t("finances.title") }}</v-flex>
      <v-flex xs12 v-if="!finances.total" class="alert-info">{{
        `finances.no_budget` | i18n
      }}</v-flex>
      <v-flex xs12 class="finances" v-if="( 1  || finances.total || finances.payed )">
            <div>
                <div class="summary">
                    <div class="chart">
                        <apexchart
                        class="canvas"
                        width="100%"
                        height="200"
                        type="donut"
                        :options="chartOptions"
                        :series="series"
                        ></apexchart>
                    </div>
                    <div class="budget_info" v-if="page == 'team'">
                        <div class="title">Informació important per fer el presupost</div>
                        <div class="content">
                            <div class="row">
                                <div class="label">{{ $t("params.estimate_players") }}:</div>
                                <div class="value">{{ data.estimate_players }}</div>
                            </div>
                            <div class="row">
                                <div class="label">{{ $t("params.estimate_staff") }}:</div>
                                <div class="value">{{ data.estimate_staff }}</div>
                            </div>
                            <div class="row">
                                <div class="label">
                                    {{ $t("params.estimate_acompanyants") }}:
                                </div>
                                <div class="value">{{ data.estimate_acompanyants }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clear" style="height: 50px"></div>

                <div id="budget_control" :class="{ visible: budget_visible }">
                    <v-switch
                        v-model="budget_visible"
                        class="input"
                        flat
                        color="#8bc34a"
                        :label="
                        budget_visible
                            ? 'El pressupost està visible a la zona privada'
                            : 'El pressupost està ocult a la zona privada'
                        "
                    ></v-switch>
                </div>
            </div>

        <v-flex xs12 v-if="1" style="text-align: right;">
          <button
            x-large
            id="add_payment"
            @click="
              addServiceDialog = true;
              $overlay.show({ loading: false });
            "
          >
            Afegir concepte
          </button>
        </v-flex>

        <v-flex xs12 id="budget">
          <v-data-table
            :headers="budget_headers"
            :items="budget_data"
            class="elevation-0"
            :no-data-text="$t('vtf.datatable.no-data')"
            :no-results-text="$t('vtf.datatable.no-data')"
            :hide-default-footer="true"
            :pagination.sync="budget_pagination"
            :rows-per-page-text="''"
            hide-actions
            item-key="id"
            group-by="category"
            show-group-by
            :loading="false"
          >
            <template v-slot:items="props">
              <tr :class="{ total: props.item.is_total }">
                <td v-if="props.item.is_category" colspan="5" class="category">
                  {{ props.item.name }}
                </td>
                <template v-else>
                  <td>{{ props.item.name }}</td>
                  
                  <td>{{ props.item.description }}</td>

                  <td v-if="props.item.edit"><input class="input" type="number" v-model="quantity_edit"></input></td>
                  <td v-else>{{ props.item.type != 2 || props.item.quantity != 1 ? props.item.units : "" }}</td>
                  
                  <td v-if="!props.item.is_total">{{ parseFloat( props.item.import ) / parseInt( props.item.units ) | toMoney }}</td>
                  <td v-else></td>

                  <td>{{ props.item.import | toMoney }}</td>

                  <td v-if="!props.item.is_total">
                      <template v-if="props.item.edit">
                          <v-btn small depressed color="#253554" dark @click="saveEditBudgetItem(props.item)">Guardar</v-btn>
                      </template>
                      <template v-else>
                          <v-icon small @click="editBudgetItem(props.item)"
                        >edit</v-icon
                        >
                        <v-icon small @click="deleteBudgetItem(props.item)"
                        >delete</v-icon
                        >
                      </template>
                    
                  </td>
                </template>
              </tr>
            </template>
            <template v-slot:headers="props">
              <tr class="table-header">
                <th
                  role="columnheader"
                  v-for="header in props.headers"
                  :key="header.text"
                  :width="header.width"
                  :class="['column']"
                  v-show="header.visible"
                >
                  {{ header.text | i18n }}
                </th>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

        <!-- <div class="objectives">
          <p>{{ `finances.objective.label` | i18n }}</p>
          <ul class="list-unstyled multi-steps">
            <li
              v-for="objective in objectives"
              class="objective"
              :class="[{'is-active': objective.active }, {'is-no_time': !objective.on_time }]"
            >
              <span class="obj-percent">{{objective.percentage}}%</span>
              <span class="obj-date">{{objective.date}}</span>
            </li>
          </ul>
        </div> -->

        <!-- <div
          class="alert-info"
          v-if="objective_active && objective_active.diff < 30 && finances.totalPercentage < objective_active.percentage"
        >{{ `finances.objective.alert.1 ` | i18n }} {{ objective_active.percentage }}% {{ `finances.objective.alert.2 ` | i18n }} {{ objective_active.date }}</div> -->
        <!-- <div class="alert" v-if="objective_no_time">
          {{ `finances.objective.error.1` | i18n }}
          {{ objective_no_time.date }}
          {{ `finances.objective.error.2` | i18n }}
          {{ objective_no_time.percentage }}%
          {{ `finances.objective.error.3` | i18n }}
        </div>
        <v-flex xs12 style="min-height: 75px;">
          <div style="display:flex; justify-content:space-between">
            <span>{{ `finances.payed` | i18n }}</span>
            <span
              ><b>{{ finances.payed }}€</b>/ {{ finances.total }}€</span
            >
          </div>
          <v-progress-linear
            rounded
            :stripped="true"
            :active="true"
            :background-opacity="1"
            :buffer-value="100"
            :height="15"
            :value="finances.totalPercentage"
            background-color="#eee"
            color="#8bc34a"
            style="margin:5px 0px;"
          ></v-progress-linear>
        </v-flex> -->
      </v-flex>
    </v-layout>

    <v-layout row wrap class="section">
      <v-flex xs12 class="name">{{ $t("titles.payments") }}</v-flex>

      <v-flex xs12 v-if="1" style="text-align: right;">
        <button
          v-if="page != 'club'"
          x-large
          id="add_payment"
          @click="
            addPaymentDialog = true;
            $overlay.show({ loading: false });
          "
        >
          {{ `finances.add_payment` | i18n }}
        </button>
      </v-flex>
      <v-flex xs12 id="payments">
        <v-data-table
          :headers="headers"
          :items="payments"
          class="elevation-0"
          :no-data-text="$t('vtf.datatable.no-data')"
          :no-results-text="$t('vtf.datatable.no-data')"
          :hide-default-footer="true"
          :pagination.sync="pagination"
          :rows-per-page-text="''"
          hide-actions
        >
          <template v-slot:items="props">
              <tr :class="{ total: props.item.is_total }">
                <!-- <td v-if="props.item.is_total" colspan="3" class="category">
                  {{ props.item.name }}
                </td>
                <td v-if="props.item.is_total" colspan="2">
                    {{ props.item.import | toMoney }}
                </td>
                <template v-else>
                </template> -->
                <td>{{ props.item.transaction.user_name }}</td>
                <td>{{ props.item.transaction.type | i18n }}</td>
                <td>{{ props.item.transaction.mode | i18n }}</td>
                <td>{{ props.item.transaction.date }}</td>
                <td>{{ props.item.transaction.affair }}</td>
                <td v-show="page == 'club'">{{ props.item.budget.team_name }}</td>
                <td>{{ props.item.import }} {{coin}}</td>
                <td>
                <v-icon v-if="!props.item.is_total && page != 'club'" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </tr>
          </template>
          <template v-slot:headers="props">
            <tr class="table-header">
              <th
                role="columnheader"
                v-for="header in props.headers"
                :key="header.text"
                :width="header.width"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                v-show="header.visible"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text | i18n }}
              </th>
            </tr>
          </template>
        </v-data-table>
        <table id="total-summary">
            <tr>
                <th colspan="3"></th>
            </tr>
            <tr class="row">
                <td width="300px"></td>
                <td class="label">{{ $t("finances.budget.received") }}</td>
                <td class="value" width="225px">{{ payments_total | toMoney }}</td>
            </tr>
            <tr class="row" v-if="budget_total">
                <td width="300px"></td>
                <td class="label">{{ $t("finances.budget.remaining") }}</td>
                <td class="value" width="225px">{{ (((budget_total - payments_total) >= 0)? (budget_total - payments_total) : 0) | toMoney }}</td>
            </tr>
            <tr class="row exceeded" v-if="budget_total && payments_total > budget_total">
                <td width="300px"></td>
                <td class="label">{{ $t("finances.budget.exceeded") }}</td>
                <td class="value" width="225px">{{ Math.abs(budget_total - payments_total) | toMoney }}</td>
            </tr>
        </table>
        
      </v-flex>
    </v-layout>
    <!-- DIALOG MANUAL PAYMENT -->
    <v-dialog v-model="addPaymentDialog" persistent width="500">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
          style="padding: 8px 10px;font-size: 20px!important;"
          >{{ `finances.add_payment` | i18n }}</v-card-title
        >

        <v-card-text style="padding: 8px 10px;margin-top:10px;">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  :label="`params.affair` | i18n"
                  required
                  v-model="affair"
                  :rules="[ v => !!v || $t('finances.conciliate.concept_required')]"
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm12 md12>
                <v-select
                  :label="`finances.payments.mode.label` | i18n"
                  required
                  v-model="mode"
                  outline
                  :items="mode_options"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-dialog
                    ref="dialog"
                    v-model="modal_date"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="date"
                        :label="$t( 'params.date' )"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" scrollable :first-day-of-week="1" locale="ca">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal_date = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                    </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm12 md12 style="min-height:70px;">
                <v-text-field
                  type="number"
                  :label="`params.import` | i18n"
                  required
                  v-model="amount"
                  v-bind:max="maxValue"
                ></v-text-field>
                <span
                  v-if="errorAmount || amount > maxValue"
                  class="errorText"
                  >{{ `finances.conciliate.error_amount` | i18n }}</span
                >
              </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" flat @click="addPaymentDialog = false;resetPaymentDialog()">{{
            `close` | i18n
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="addPayment()">{{
            `save` | i18n
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG ADD CONCEPT -->
    <v-dialog persistent v-model="addServiceDialog" width="800">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
          style="padding: 8px 10px;font-size: 20px!important;"
          >{{ `finances.add_concept` | i18n }}</v-card-title
        >

        <v-card-text style="padding: 8px 10px;margin-top:10px;">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs12 class="title">{{ $t( "finances.sel_concept_type" ) }}</v-flex>
                        <v-flex xs12 md4 class="concept_type" @click="serviceSelected = true; discountSelected = false;"><div class="label" :class="{'selected': serviceSelected}">{{ $t( "finances.sel_concept_service" ) }}</div></v-flex>
                        <v-flex xs12 md4 class="concept_type" @click="serviceSelected = false; discountSelected = true;"><div class="label" :class="{'selected': discountSelected}">{{ $t( "finances.sel_concept_discount" ) }}</div></v-flex>
                    </v-layout>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md12 style="min-height:20px;"></v-flex>
              <v-flex xs12 sm12 md12 style="min-height:70px;" v-if="serviceSelected">
                  <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs6>
                            <v-select
                                :items="services_type_list"
                                :label="'finances.services.sel_category' | i18n"
                                outline
                                v-model="service_type_selected"
                            ></v-select>
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                :items="services_list"
                                :label="'finances.services.sel_service' | i18n"
                                outline
                                v-model="service_selected"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 class="description">
                            {{ service_selected_description | i18n }}
                        </v-flex>
                        <v-flex xs6>
                           <v-text-field
                                type="number"
                                :label="`params.quantity` | i18n"
                                required
                                v-model="service_quantity"
                                v-bind:min="1"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                type="number"
                                :label="`finances.services.price` | i18n"
                                required
                                v-model="service_price"
                                v-bind:min="0"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                  </v-container>
                <!-- <span
                  v-if="errorAmount || amount > maxValue || amount == 0"
                  class="errorText"
                  >{{ `finances.conciliate.error_amount` | i18n }}</span
                > -->
              </v-flex>
              <v-flex xs12 sm12 md12 style="min-height:70px;" v-if="discountSelected">
                  <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs6>
                            <v-select
                                :items="services_type_list"
                                :label="'finances.services.sel_category' | i18n"
                                outline
                                v-model="service_type_selected"
                            ></v-select>
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                :items="discounts_list"
                                :label="'finances.services.sel_discount' | i18n"
                                outline
                                v-model="discount_selected"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 class="description">
                            {{ discount_selected_description | i18n }}
                        </v-flex>
                        <v-flex xs6>
                           <v-text-field
                                type="number"
                                :label="`params.quantity` | i18n"
                                required
                                v-model="discount_quantity"
                                v-bind:min="1"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                type="number"
                                :label="`finances.discounts.price` | i18n"
                                required
                                v-model="discount_price"
                                v-bind:min="0"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                  </v-container>
                <!-- <span
                  v-if="errorAmount || amount > maxValue || amount == 0"
                  class="errorText"
                  >{{ `finances.conciliate.error_amount` | i18n }}</span
                > -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" flat @click="addServiceDialog = false;resetConceptDialog();">{{
            `close` | i18n
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="addConcept()">{{
            `save` | i18n
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: { page: String, data: Object, bus: Object },
  data() {
    return {
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: false
          }
        },
        legend: {
          position: "right",
          horizontalAlign: "center",
          offsetY: 50
        },
        colors: ["#8bc34a", "#ddd"],
        labels: ["Pagat", "Pendent"],
        dataLabels: {
          enabled: false,
          formatter: function(val, opts) {
            return Math.round(Math.abs(val)) + "%";
          }
        },
        stroke: {
          width: 2,
          colors: ["#fff"]
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function(val) {
              return Math.abs(val) + "€";
            }
          },
          style: {
            fontSize: "10px"
          },
          fillSeriesColor: false,
          theme: "light"
        }
      },
      mode_options: [
          { value: 1, text: i18n.t( "finances.payments.mode.transferencia" ) },
          { value: 2, text: i18n.t( "finances.payments.mode.tpv" ) },
          { value: 3, text: i18n.t( "finances.payments.mode.efectiu" ) },
      ],
      budget_visible: true,
      budget_headers: [
        {
          text: "Concepte",
          value: "name",
          visible: true,
          width: "25%"
        },
        {
          text: "Descripció",
          value: "description",
          visible: true,
          width: "45%"
        },
        {
          text: "Unitats",
          value: "units",
          visible: true
        },
        {
          text: "Preu unitari",
          value: "unit_price",
          visible: true
        },
        {
          text: this.$t(`params.import`),
          value: "import",
          visible: true
        },
        {
          text: this.$t(`params.actions`),
          value: "Actions",
          visible: true,
          width: "100px"
        }
      ],
      budget_pagination: {
        sortBy: "transaction.date",
        descending: true,
        rowsPerPage: -1,
        page: 1,
        totalItems: 0,
        totalFilteredItems: 0
      },

      objective_active: {},
      objective_no_time: false,
      amount: 0,
      amountSelected: "",
      addPaymentDialog: false,
      addServiceDialog: false,
      serviceSelected: true,
      discountSelected: false,
      service_type_selected: false,
      service_selected: false,
      service_selected_description: '',
      service_quantity: 0,
      service_price: 0,
      discount_selected: false,
      discount_selected_description: '',
      discount_quantity: 0,
      discount_price: 0,
      quantity_edit: 0,
      import_edit: 0,
      errorAmount: false,
      affair: '',
      mode: 1,
      date: moment().format("YYYY-MM-DD"),
      modal_date: false,
      headers: [
        {
          text: this.$t(`params.mic_gestor`),
          value: "transaction.user_name",
          visible: true,
          width: "300px",

        },
        {
          text: this.$t(`finances.payments.type.label`),
          value: "transaction.type",
          visible: true,
          width: "150px",

        },
        {
          text: this.$t(`finances.payments.mode.label`),
          value: "transaction.mode",
          visible: true,
          width: "150px",

        },
        {
          text: this.$t(`params.date`),
          value: "transaction.date",
          visible: true,
          width: "150px",
        },
        {
          text: this.$t(`params.affair`),
          value: "transaction.affair",
          visible: true,
        },
        {
          text: this.$t(`params.team`),
          value: "transaction.team_name",
          visible: this.page == "club"
        },
        {
          text: this.$t(`params.import`),
          value: "import",
          visible: true,
          width: "150px",
        },
        {
          text: this.$t(`params.actions`),
          value: "Actions",
          visible: true,
          width: "75px",
        }
      ],
      pagination: {
        sortBy: "transaction.date",
        descending: true,
        rowsPerPage: -1,
        page: 1,
        totalItems: 0,
        totalFilteredItems: 0
      }
    };
  },
  computed: {
    coin(){
        let event = this.$store.getters[ 'events/getCurrentEvent' ]()
        return event.type_id == 15 ? '$' : '€'
    },
    series() {
      return [this.finances.payed, this.finances.total - this.finances.payed];
    },
    maxValue() {
      return this.finances.total - this.finances.payed;
    },
    finances() {
      var path = `finances/get_${this.page}_budget_by_id`;
      var oFinances = {
        ...this.$store.getters[path](this.data.id)
      };

      oFinances.totalPercentage = oFinances.total
        ? Math.round((oFinances.payed * 100) / oFinances.total)
        : 100;
      return oFinances;
    },
    objectives() {
      var objectives = { ...this.$store.getters["finances/getObjectives"]() };
      this.objective_no_time = false;
      var bFiff = false;
      var selected = false;
      for (var i in objectives) {
        var date = moment(objectives[i].date);
        var today = moment(new Date());
        var diff = date.diff(today, "days");
        var counter = 0;
        objectives[i].on_time = true;
        if (!bFiff) {
          selected = { ...objectives[i] };
        }

        if (bFiff < 0 && diff > 0) {
          if (selected.percentage > this.finances.totalPercentage) {
            objectives[selected.id].on_time = false;
            this.objective_no_time = objectives[selected.id];
            this.objective_no_time.counter = counter++;
          }
          selected = { ...objectives[i] };
        }

        if (bFiff > 0 && diff > 0 && bFiff > diff) {
          if (selected.percentage > this.finances.totalPercentage) {
            objectives[selected.id].on_time = false;
            this.objective_no_time = objectives[selected.id];
            this.objective_no_time.counter = counter++;
          }
          selected = { ...objectives[i] };
        }

        bFiff = diff;
      }
      if (objectives[selected.id] != undefined) {
        objectives[selected.id].active = true;
        objectives[selected.id].diff = bFiff;
        this.objective_active = objectives[selected.id];
      }

      return objectives;
    },
    payments() {
      var path = `finances/getPaymentsCard`;
      var payments = {
        ...this.$store.getters[path](this.data.id)
      };
      var result = [];
      var n_total = 0;
      for (const key in payments) {
        payments[key].transaction.user_name = payments[key].transaction.user_id ? this.$store.getters['user/get_by_id']( payments[key].transaction.user_id ).name : '-'
        result.push(payments[key]);
        n_total += parseFloat( payments[key].import );
      }
    //   result.push({
    //         is_total: true,
    //         name: "Total",
    //         import: n_total
    //   })
      return result;
    },

    payments_total() {
        var total = 0;
        for (const key in this.payments) {
            total += parseFloat( this.payments[key].import );
        }
        return total;
    },

    services_type_list() {
        var event = this.$store.getters['events/getCurrentEvent']()
        var aServicesTypeList = ObjectToArray( this.$store.state.service_type )
        var aList = []
        var self = this
        aServicesTypeList.forEach( item => {
            if( parseInt(item.event_type) == parseInt(event.type_id) ){
                if( self.serviceSelected ){
                    var aServicesList = ObjectToArray( this.$store.getters[ 'finances/get_services']( item.id ) )
                    if( aServicesList.length > 0 ){
                        aList.push({
                            text: i18n.t( item.name ),
                            value: item.id
                        })
                    }
                }
                else if( self.discountSelected ){
                    var aDiscountsList = ObjectToArray( this.$store.getters[ 'finances/get_discounts']( item.id ) )
                    if( aDiscountsList.length > 0 ){
                        aList.push({
                            text: i18n.t( item.name ),
                            value: item.id
                        })
                    }
                }                
            }
        })

        return aList
    },

    services_list() {
        var aServicesList = ObjectToArray( this.$store.getters[ 'finances/get_services']( this.service_type_selected ) )
        var aList = []
        var self = this

        aServicesList.forEach( item => {
            if( item.type == self.service_type_selected ){
                aList.push({
                    text: i18n.t( item.name ),
                    value: item.id
                })
            }
        })

        return aList
    },

    discounts_list() {
        var aDiscountsList = ObjectToArray( this.$store.getters[ 'finances/get_discounts']( this.service_type_selected ) )
        var aList = []
        var self = this

        aDiscountsList.forEach( item => {
            aList.push({
                text: i18n.t( item.name ),
                value: item.id
            })
        })

        return aList
    },

    budget_data(){
        var aBudgetData = []
        var aServicesTypeList = ObjectToArray( this.$store.state.service_type )
        var oServicesList = this.$store.getters[ 'finances/get_services' ]()
        var oDiscountsList = this.$store.getters[ 'finances/get_discounts' ]()
        var oBudget = this.$store.getters[ `finances/get_${this.page}_budget_by_id`]( this.data.id )
        var self = this
        var aDiscounts = []

        if( oBudget ){
            aServicesTypeList.forEach( service_type => {
                var service_type_added = false
                if( oBudget.services ){
                    oBudget.services.forEach( service => {
                        if( service.service_id ){
                            var oService = this.$store.getters[ 'finances/get_service_by_id' ]( service.service_id )
                            if( typeof oService !== 'undefined' && oService.type == service_type.id ){
                                if( !service_type_added ){
                                    service_type_added = true
                                    aBudgetData.push({
                                        is_category: true,
                                        name: i18n.t( service_type.name )
                                    })
                                }

                                aBudgetData.push({
                                    id: service.id,
                                    name: i18n.t( oService.name ),
                                    description: i18n.t( oService.description ),
                                    units: service.quantity,
                                    import: service.import,
                                    type: 1, //oService.type,
                                    edit: service.edit
                                })
                            }
                        }
                        else if( service.discount_id ){
                            var oDiscount = this.$store.getters[ 'finances/get_discount_by_id' ]( service.discount_id )
                            // console.log( oDiscount )
                            if( oDiscount.type == service_type.id ){
                                aDiscounts.push({
                                    id: service.id,
                                    name: i18n.t( oDiscount.name ),
                                    description: i18n.t( oDiscount.description ),
                                    units: service.quantity,
                                    import: service.import,
                                    type: 2, //oService.type
                                    edit: service.edit
                                })
                            }
                        }
                    })
                }
            })

            if( aDiscounts.length > 0 ){
                aBudgetData.push({
                    is_category: true,
                    name: i18n.t( 'finances.discounts.label' )
                })
                aDiscounts.forEach( discount => {
                    aBudgetData.push({
                        id: discount.id,
                        name: discount.name,
                        description: discount.description,
                        units: discount.units,
                        import: discount.import,
                        type: discount.type, //oService.type
                        edit: discount.edit
                    })
                })
            }

            //ADDED TOTAL BUDGET
            aBudgetData.push({
                is_total: true,
                name: "Total",
                import: oBudget.total
            })
        }

        return aBudgetData
    },

    budget_total() {
         var oBudget = this.$store.getters[ `finances/get_${this.page}_budget_by_id`]( this.data.id )
         return oBudget.total;
    },
  },
  methods: {
    addPayment() {
    //   if (this.page == "team") {
        if (this.amount == 0) {
          this.errorAmount = true;
          return false;
        }
        if( this.affair.trim() == "" ) return false
        var payload = {
          team_id: this.data.id,
          amount: this.amount,
          affair: this.affair,
          date: this.date,
          mode: this.mode
        };
        var path = "finances/addPayment";
        var self = this;
        this.$store.dispatch(path, payload).then(function(response) {
          if (response) {
            self.initialData();
            self.addPaymentDialog = false;
            self.resetPaymentDialog();
          }
        });
    //   }
    },
    resetPaymentDialog(){
        this.amount = 0
        this.affair = ''
        this.date = moment().format("YYYY-MM-DD")
        this.mode = 1
    },
    resetConceptDialog(){
        this.service_type_selected = false
        this.service_selected = false
        this.service_quantity = 0
        this.service_price = 0
        this.discount_selected = false
        this.discount_quantity = 0
        this.discount_price = 0
    },
    addConcept() {
        if ( this.serviceSelected ) {
            if (this.service_quantity <= 0 || this.service_price < 0 ) {
                this.errorService = true;
                return false;
            }
            var payload = {
                event_id: this.$store.getters['events/getCurrentEvent']().id,
                entity_id: this.data.id,
                entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
                service_id: this.service_selected, 
                quantity: this.service_quantity,
                import: this.service_price
            };
            var path = "finances/addService";
        }
        else if ( this.discountSelected ) {
            var payload = {
                event_id: this.$store.getters['events/getCurrentEvent']().id,
                entity_id: this.data.id,
                entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
                discount_id: this.discount_selected, 
                quantity: this.discount_quantity,
                import: this.discount_price
            };
            var path = "finances/addDiscount";
        }

        var self = this;
        this.$store.dispatch(path, payload).then(function(response) {
            if (response) {
                self.initialData();
                self.addServiceDialog = false;
                self.resetConceptDialog()
            }
        });
    },
    editBudgetItem( billing_service ){
        var oBudget = JSON.parse( JSON.stringify( this.$store.getters[ `finances/get_${this.page}_budget_by_id`]( this.data.id ) ) )
        var self = this
        oBudget.services.forEach( line => {
            if( line.id == billing_service.id ){
                line.edit = true
                self.quantity_edit = line.quantity
                self.import_edit = line.import / line.quantity
            }
            else{
                line.edit = false
            }
        })
        
        var page = this.page.charAt(0).toUpperCase() + this.page.slice(1)
        this.$store.commit( `finances/add${page}`, oBudget )
    },
    saveEditBudgetItem( billing_service ){
        var oBudget = JSON.parse( JSON.stringify( this.$store.getters[ `finances/get_${this.page}_budget_by_id`]( this.data.id ) ) )
        var self = this

        var lineAux = false
        oBudget.services.forEach( line => {
            if( line.id == billing_service.id ){
                line.quantity = self.quantity_edit
                line.import = line.quantity * self.import_edit

                lineAux = line
            }
        })
        
        // var page = this.page.charAt(0).toUpperCase() + this.page.slice(1)
        // this.$store.commit( `finances/add${page}`, oBudget )

        if( lineAux.service_id ){
            var oParams = {
                event_id: this.$store.getters['events/getCurrentEvent']().id,
                entity_id: this.data.id,
                entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
                service_id: lineAux.service_id,
                quantity: this.quantity_edit,
                import: this.quantity_edit * this.import_edit
            }
            this.$store.dispatch( 'finances/updateServiceBilling', oParams ).then( function(){
                self.initialData()
            } )
        }
        else if( lineAux.discount_id ){
            var oParams = {
                event_id: this.$store.getters['events/getCurrentEvent']().id,
                entity_id: this.data.id,
                entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
                discount_id: lineAux.discount_id,
                quantity: this.quantity_edit,
                import: this.import_edit * -1
            }
            this.$store.dispatch( 'finances/removeDiscount', oParams ).then( function(){
                self.$store.dispatch( 'finances/addDiscount', oParams ).then( function(){
                    self.initialData()
                } )
            } )
        }
    },
    deleteBudgetItem( billing_service ){
        var oBudget = JSON.parse( JSON.stringify( this.$store.getters[ `finances/get_${this.page}_budget_by_id`]( this.data.id ) ) )
        var self = this

        var lineAux = false
        oBudget.services.forEach( line => {
            if( line.id == billing_service.id ){
                lineAux = line
            }
        })

        var oParams = {
            event_id: this.$store.getters['events/getCurrentEvent']().id,
            entity_id: this.data.id,
            entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
            billing_line_id: lineAux.id,
        }
        var self = this

        this.$popup.confirm({
            message: i18n.t( "finances.services.delete" ),
            btnSuccess: i18n.t( 'accept' ),
            btnError: i18n.t( 'cancel' )
        }, function(){
            self.$store.dispatch( 'finances/removeBillingService', oParams ).then( function(){
                self.initialData()
            } )
        },
        function(){
            self.$comboSelector.close();
        })
        
    },
    amountSelector() {
      let budget = this.budgets[this.selected];
      let total = this.finances.total - this.finances.payed;
      let budgetPercent =
        Math.round(total * (amountSelected / 100) * 100) / 100;
      let transactionPercent =
        Math.round(this.transaction.import * (amountSelected / 100) * 100) /
        100;
      this.amount =
        budgetPercent > transactionPercent ? transactionPercent : budgetPercent;
    },
    deleteItem(item) {
      var self = this;
    //   this.$store
    //     .dispatch("finances/load_transaction", item.transaction.id_transaction)
    //     .then(function() {
    //       var otransaction = {
    //         ...self.$store.getters["finances/get_transaction_by_id"](
    //           item.transaction.id_transaction
    //         )
    //       };
    //       console.log( otransaction );
    //       self.$card.finances(otransaction, function(){ self.initialData() });
    //     });
        self.$popup.confirm(
            {
                message: i18n.t("finances.payments.delete_confirm"),
                btnSuccess: i18n.t("accept"),
                btnError: i18n.t("cancel")
            },
            function() {
                self.$store
                .dispatch("finances/deletePayment", item.id)
                .then(response => {
                    self.initialData()
                    self.$popup.close()
                });
            },
            function() {}
        );
    },
    initialData() {
        var path = `finances/loadServices`;
        var self = this;
        self.$store.dispatch(path, self.$store.getters['events/getCurrentEvent']().id).then(function() {
            path = `finances/loadDiscounts`;

            self.$store.dispatch(path, self.$store.getters['events/getCurrentEvent']().id).then(function() {
                path = `finances/load_${self.page}_by_id`;
                var oParams = {
                    id: self.data.id
                };
                
                self.$store.dispatch(path, oParams).then(function() {
                    //falta substituir el 1 por el event_id
                    // self.$store.dispatch("finances/objective", 1).then(function() {});
                    path = `finances/payments_${self.page}_card`
                        // self.page == "team"
                        //   ? `finances/payments_${self.page}_card`
                        //   : `finances/payments_${self.page}`;

                    self.$store.dispatch(path, self.data.id).then(function() {
                        var oBudget = JSON.parse( JSON.stringify( self.$store.getters[ `finances/get_${self.page}_budget_by_id`]( self.data.id ) ) )
                        self.budget_visible = oBudget.visible;
                    });
                });
            }); 
        });
        
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  created() {
    this.initialData();
  },
  mounted() {
      this.bus.$on('reload', this.initialData)
  },
  watch: {
    $route: "initialData",
    addPaymentDialog: {
      handler(v) {
        if (!v) {
          this.$overlay.hide();
        }
      },
      deep: true
    },
    addServiceDialog: {
      handler(v) {
        if (!v) {
          this.$overlay.hide();
        }
      },
      deep: true
    },
    service_selected: {
      handler(v) {
        var s = this.$store.getters['finances/get_service_by_id']( v )
        if( s ){
            if( this.service_quantity == 0 ) this.service_quantity = 1
            this.service_price = parseFloat( s.import )
            this.service_selected_description = s.description;
        }
      },
      deep: true
    },
    discount_selected: {
      handler(v) {
        var s = this.$store.getters['finances/get_discount_by_id']( v )
        if( s ){
            if( this.discount_quantity == 0 ) this.discount_quantity = 1
            this.discount_price = parseFloat( s.value )
            this.discount_selected_description = s.description;
        }
      },
      deep: true
    },
    budget_visible: {
      handler(v) {
        var visible = v ? 1 : 0;
        var self = this;
        var oParams = {
            event_id: this.$store.getters['events/getCurrentEvent']().id,
            entity_id: this.data.id,
            entity: this.$store.getters['events/getCurrentEvent']().is_campus ? 3 : 2,
            visible: visible,
        }

        this.$store.dispatch( 'finances/updateBudgetVisible', oParams ).then( function(){
            self.initialData()
        })
      },
      deep: true
    },
  }
};
</script>

<style lang="scss">
    .v-picker__actions .v-btn__content {
        color: #000;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance:textfield;
    }

</style>

<style lang="scss" scoped>
.objectives {
  margin-bottom: 30px;
}
.objective {
  .obj-percent,
  .obj-date {
    display: block;
    position: absolute;
    left: calc(50% + 25px);
    top: -3px;
  }

  .obj-percent {
    font-weight: bold;
  }
  .obj-date {
    top: 18px;
    font-size: 16px;
  }
}

.summary {
  overflow: hidden;
  display: block;
  width: 100%;

  .chart {
    width: 35%;
    display: block;
    float: left;
  }
  .budget_info {
    width: 60%;
    margin-left: 5%;
    display: block;
    float: left;
    padding: 20px;
    margin-top: 15px;
    border-left: 0px solid #ef953a;
    background: #fff6e6;

    .title {
      font-size: 14px !important;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 15px;
      border-bottom: 2px solid #ef953a;
      padding-bottom: 5px;
    }
    .content {
      overflow: hidden;
      padding: 15px;
      margin: 0;

      .row {
        text-align: center;
        width: calc(100% / 3);
        float: left;

        .label {
          text-align: center;
          font-size: 12px;
        }
        .value {
          font-size: 24px;
          font-family: Roboto-Bold;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
}

.section {
  .name {
    font-weight: lighter;
    font-size: 24px;
    @include font-size(14px);
    border-bottom: 1px solid #ddd;
    margin: 10px 0 20px 0;
    color: $main-color;
    text-transform: uppercase;
    margin-bottom: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid $complem-color-dark;
    color: $complem-color-dark;
    position: relative;
  }
}
.alert {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert-info {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

$brand-primary: green;
$white: #fff;
$grey-light: #ededed;
%remain-steps {
  &:before {
    content: counter(stepNum);
    font-family: inherit;
    font-weight: 700;
  }
  &:after {
    background-color: $grey-light;
  }
}
.multi-steps {
  display: table;
  table-layout: fixed;
  width: 100%;
  margin-bottom: 15px;

  li {
    counter-increment: stepNum;
    text-align: center;
    display: table-cell;
    position: relative;
    color: $brand-primary;
    z-index: 1;
    &:before {
      content: "\f00c";
      content: "\2713;";
      content: "\10003";
      content: "\10004";
      content: "\2713";
      display: block;
      margin: 0 auto 4px;
      background-color: $white;
      width: 36px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
      border: {
        width: 2px;
        style: solid;
        color: $brand-primary;
        radius: 50%;
      }
    }
    &:after {
      content: attr(data-content);
      padding-left: 25px;
      text-align: left;
      height: 2px;
      width: 100%;
      background-color: $brand-primary;
      position: absolute;
      top: 16px;
      left: 50%;
      z-index: -1;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }

    &.is-active {
      color: white;
      @extend %remain-steps;
      &:before {
        background-color: $main-color;
        border-color: $main-color;
      }

      ~ li {
        color: #808080;
        @extend %remain-steps;
        &:before {
          background-color: $grey-light;
          border-color: $grey-light;
        }
      }
    }
    &.is-unfulfilled {
      @extend %remain-steps;
      &:before {
        background-color: $white;
        border-color: red;
      }

      ~ li {
        color: #808080;
        @extend %remain-steps;
        &:before {
          background-color: $grey-light;
          border-color: red;
        }
      }
    }
  }

  > .is-no_time {
    color: white !important;
    speak-as: dark;
    span:first-of-type {
      color: #d20000;
    }
    &:before {
      content: "x" !important;
      font-size: 15px;
      background-color: red !important;
      border: {
        color: red !important;
      }
    }
    &:after {
      background-color: #ededed !important;
    }
  }

  > .is-no_time + .is-active {
    color: black;
    &:before {
      font-size: 15px;
      background-color: white !important;
      border: {
        color: red !important;
      }
    }
  }
}
#add_payment {
  text-align: center;
  border-radius: 3px;
  font-size: 12px;
  text-transform: uppercase;
  color: #fff;
  padding: 8px 15px;
  cursor: pointer;
  background-color: #172654;

  &:hover {
    background-color: #253554;
  }
}

.amountSelector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  div {
    width: 60px;
  }
  input {
    width: 60%;
  }
  button {
    height: 25px;
    width: 70px;
    text-align: center;
    border-radius: 3px;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    background-color: #172654;

    &:hover {
      background-color: #253554;
    }
  }
}
.closeBtn {
  &:after {
    cursor: pointer;
    content: "\2A2F";
  }
}

#total-summary {
    width: 100%;
    border-top: 2px solid #828aa0;
    padding-top: 10px;
    margin-bottom: 50px;

    th {
        height: 15px;
    }

    .row {
        width: 100%;
        overflow: hidden;
        padding: 5px;

        td {
            padding: 5px 24px;

            &.label {
                text-align: right;
                font-size: 14px;
                text-transform: uppercase;
            }

            &.value {
                font-weight: bold;
                font-family: Roboto-Bold;
                font-size: 16px;
            }
        }

        &.exceeded {
            td {

                &.label {
                    color: #d42525;
                }

                &.value {
                    color: #d42525;
                }
            }
            
        }

    }
}

#budget_control {
  padding: 5px 10px 0px 10px;
  border-radius: 2px;
  width: 60%;
  height: 45px;
  float: left;

  &.visible {
    background-color: #ebf6eb;
  }
  .input {
    border-bottom: 0;
  }
}


.errorText {
  font-size: 11px;
  color: red;
  margin-top: -21px;
}
> .v-text-field__details {
  display: none;
}

.table-header {
  .column {
    padding: 0 !important;
    text-align: left !important;
  }
}

.subtitle {
  text-transform: uppercase;
  font-weight: lighter;
  font-size: 16px;
  color: #333;
}

.concept_type {
    padding: 0 10px;

    .label {
        text-align: center;
        border: 1px solid #acac;
        border-radius: 10px;
        cursor: pointer;
        padding: 5px 10px;

        &.selected {
            border: 2px solid $main-color;
        }
    }
}

.description {
    margin-bottom: 20px;
    font-size: 14px;
    font-family: Roboto-Light;
    font-style: italic;
}
</style>

<style lang="scss">
#budget_control .v-input__slot {
  border-bottom: 0 !important;
  margin-bottom: 0;
}
#budget_control label {
  font-size: 14px !important;
}
#budget {
    margin-bottom: 50px;
    th {
    padding: 6px 10px 0 15px !important;
    border-bottom: 0px solid #fff;
    }
    td {
    background-color: #fff;
    padding: 10px;
    }
    .v-datatable__progress {
    display: none !important;
    }
    .category {
    padding: 10px;
    background-color: #f7f7f7;
    color: #4f5462;
    text-transform: uppercase;
    font-family: AvantGarde-Bold;
    }
    .total {
    border-top: 3px solid #828aa0;
    td {
        font-weight: bold;
        font-family: Roboto-Bold;
        padding: 15px 10px;
        font-size: 16px;
        text-transform: uppercase;
    }
    }
    .input {
        border: 1px solid #ccc;
        padding: 5px 10px;
        border-radius: 3px;
        width: 75px;
    }
}
#total-summary {
    width: 100%;
    border-top: 3px solid #828aa0;
    padding-top: 10px;
    margin-bottom: 50px;
    th {
        height: 15px;
    }
    .row {
        width: 100%;
        overflow: hidden;
        padding: 5px;
        td {
            padding: 5px 24px;
            &.label {
                text-align: right;
                font-size: 14px;
                text-transform: uppercase;
            }
            &.value {
                font-weight: bold;
                font-family: Roboto-Bold;
                font-size: 16px;
            }
        }
        &.exceeded {
            td {
                &.label {
                    color: #d42525;
                }
                &.value {
                    color: #d42525;
                }
            }
        }
    }
}

#payments {
  margin-top: 10px;
  
  .v-toolbar__title {
    color: white;
  }
  .total {
    border-top: 2px solid #828aa0;
    td {
      font-weight: bold;
      font-family: Roboto-Bold;
      padding: 15px 10px;
      font-size: 16px;
      text-transform: uppercase;
    }
  }
}
</style>
